import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyConversionService } from '../../../../Core/Users/services/currency-conversion.service';
import { UserCurrency } from '../../../../Core/Users/enums/user-currency';
@Pipe({
    name: 'CurrencyConversion',
    standalone: false
})
export class CurrencyConversionPipe implements PipeTransform {
    constructor(
        private conversionService: CurrencyConversionService
    ) { }

    transform(value: any, appendCurrencyCode = true, target?: UserCurrency) {
        return this.conversionService.convertCurrency(value, appendCurrencyCode, target);
    }


}
